<template>
    <fs v-model="fullscreen" class="h-full w-full select-none bg-white">
    <div class="h-full relative  overflow-hidden">
        <div class="bg-secondary text-white flex items-center justify-center p-4 font-bold">
            XOX
        </div>
        <div class="flex flex-col h-full">
            <div class="flex flex-col lg:flex-row lg:justify-between h-full">
                <div class="w-full  h-full">
                    <Game :files_url="files_url" :volume="volume" :classSize="classSize" :isStart="isStart" @is_start="isStart = $event" @winners="handleWinners"/>
                </div>
                <div class="w-full lg:w-2/6 h-full bg-gray-100">
                    <Result :winners="winners"/>
                </div>
            </div>
        </div>

        <div class="absolute top-0 left-0 w-full h-full"  v-if="!isStart">
            <div class="bg-secondary absolute top-0 left-0 w-full h-full opacity-20 z-10"></div>
            <div class="absolute top-0 left-0 w-full h-full z-20 flex items-center justify-center">
                <div class="bg-primary-default w-full m-4 md:w-1/2 py-8 px-4 flex flex-col space-y-8 rounded-lg">

                    <!-- Sınıf Mevcudu -->
                    <div class="flex flex-col items-center">
                        <div class="text-sm text-white">Sınıf Mevcudu</div>
                        <div class="flex space-x-2 p-4 items-center justify-center">
                            <div>
                                <input class="p-2 rounded-lg w-16 text-2xl text-center" type="number" v-model="classSize">
                            </div>
                            <div class="flex space-x-2">
                                <button class="text-2xl font-bold bg-secondary px-4 py-2 rounded-lg text-white" @click="classSize--">-</button>
                                <button class="text-2xl font-bold bg-secondary px-4 py-2 rounded-lg text-white" @click="classSize++">+</button>
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center justify-center">
                        <button class="bg-secondary text-white rounded-lg px-4 py-2" @click="isStart = true">Başla</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- voice and  full screen-->
        <div class="absolute right-2 bottom-2  z-40">
            <div class="flex justify-center items-center space-x-3">
                <button @click="volume = !volume">
                    <VolumeUpIcon class="w-6 lg:w-8" v-if="volume"/>
                    <VolumeOffIcon class="w-6 lg:w-8" v-else/>
                </button>

                <button @click="fullscreen = !fullscreen">
                    <ArrowsExpandIcon class="w-6 lg:w-8"/>
                </button>
            </div>
        </div>

    </div>
    </fs>
</template>


<script setup>
import {ArrowsExpandIcon, ReplyIcon, VolumeOffIcon, VolumeUpIcon} from "@heroicons/vue/outline";
import {ref, defineProps} from 'vue'
import Game from './components/screen/game.vue';
import Result from './components/screen/result.vue';
import { earnGameCompletionBadge } from '../../helpers/badge';

const props     = defineProps(['files_url'])


const isStart       = ref(false)
const fullscreen    = ref(false)
const volume        = ref(true)
const winners       = ref([])
const classSize     = ref(4)
const gameCompleted = ref(false)

// Oyun tamamlandığında rozet kazanma işlevi
const handleWinners = (newWinners) => {
    winners.value = newWinners;
        
    if (newWinners.length > 0 && !gameCompleted.value) {
        gameCompleted.value = true;
        earnGameCompletionBadge();
    }
}
</script>
